/* eslint-disable consistent-return */
import { loaderService } from 'src/services/loaderService';
import apiService from 'src/enviroment';

const getAllDestinataries = async () => {
  loaderService.show();
  const { status, data } = await apiService.get('/maestros/destinatarios/');
  try {
    if (status === 200) {
      return data;
    }
    return [];
  } catch (error) {
    loaderService.hide();
  } finally {
    loaderService.hide();
  }
};

const getDestinatariesWithM2 = async () => {
  loaderService.show();
  const { status, data } = await apiService.get('/destinatarios/maestros/m2/');
  try {
    if (status === 200) {
      return data;
    }
    return [];
  } catch (error) {
    loaderService.hide();
  } finally {
    loaderService.hide();
  }
};

const updateM2 = async (body) => {
  loaderService.show();
  const { status, data } = await apiService.put('/destinatarios/maestros/m2/', body);
  try {
    if (status === 200) {
      return data.success;
    }
    return false;
  } catch (error) {
    loaderService.hide();
  } finally {
    loaderService.hide();
  }
};
// NUEVOS SERVICIOS

const getM2 = async (id) => {
  loaderService.show();
  const response = await apiService.get(`/informacion/puntos/m2/?unidad_negocio=${id}`);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};
const putM2 = async (params) => {
  loaderService.show();
  const response = await apiService.put('/informacion/puntos/m2/', params);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};
const getChannels = async (id) => {
  loaderService.show();
  const response = await apiService.get(`/segmentacion/canales/?unidad_negocio=${id}`);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const destinaterieM2Service = {
  putM2,
  getM2,
  updateM2,
  getChannels,
  getAllDestinataries,
  getDestinatariesWithM2,
};

export default destinaterieM2Service;
